// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collaborator-modal {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  height: auto;
  width: 500px;
  border-radius: 4px !important;
}
.collaborator-modal:focus-visible {
  outline: none !important;
}
.remove-margin button {
  margin: 0 !important;
}

.modal-box{
    max-height: 100vh;
    padding: 5px 100vw;
    overflow: scroll;
}
.modal-box:focus-visible {
    outline:none !important;
}
.mui-box:focus-visible {
    outline:none !important;
}
.acc-card{
  width: 311px;
height: 99.736px;
border-radius: 4px;
background: var(--neutral-white, #FFF);
box-shadow: 0px 15px 28px 0px rgba(0, 0, 0, 0.05);
display:flex;
}
.acc-collab-del svg{
  color: #da1414;
  opacity: 0.6;
  cursor: pointer;
  font-size: 18px;
  margin-right: 4px;
}
.acc-collab-name {
  font-weight: 400;
  font-size: 16px;
  color: #424242;
}
.acc-collab-location{
  color:  #68AD3F;
font-size: 12px;
font-weight: 500;
opacity: 0.6000000238418579;
}
.acc-collab-right{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 7px;
  padding: 10px;
  width:100%;
}
@media only screen and (min-width: 0px) and (max-width: 480px) {
  .collaborator-modal {
    width: 300px;
  }
}
@media only screen and (min-width: 481px) and (max-width: 767px) {
  .collaborator-modal {
    width: 450px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Modals/OrganizerModel/ManageFeis/Events/CollaboratorModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,oBAAoB;AACtB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;EACE,YAAY;AACd,gBAAgB;AAChB,kBAAkB;AAClB,sCAAsC;AACtC,iDAAiD;AACjD,YAAY;AACZ;AACA;EACE,cAAc;EACd,YAAY;EACZ,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;AACjB,eAAe;AACf,gBAAgB;AAChB,2BAA2B;AAC3B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,UAAU;AACZ;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".collaborator-modal {\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  height: auto;\n  width: 500px;\n  border-radius: 4px !important;\n}\n.collaborator-modal:focus-visible {\n  outline: none !important;\n}\n.remove-margin button {\n  margin: 0 !important;\n}\n\n.modal-box{\n    max-height: 100vh;\n    padding: 5px 100vw;\n    overflow: scroll;\n}\n.modal-box:focus-visible {\n    outline:none !important;\n}\n.mui-box:focus-visible {\n    outline:none !important;\n}\n.acc-card{\n  width: 311px;\nheight: 99.736px;\nborder-radius: 4px;\nbackground: var(--neutral-white, #FFF);\nbox-shadow: 0px 15px 28px 0px rgba(0, 0, 0, 0.05);\ndisplay:flex;\n}\n.acc-collab-del svg{\n  color: #da1414;\n  opacity: 0.6;\n  cursor: pointer;\n  font-size: 18px;\n  margin-right: 4px;\n}\n.acc-collab-name {\n  font-weight: 400;\n  font-size: 16px;\n  color: #424242;\n}\n.acc-collab-location{\n  color:  #68AD3F;\nfont-size: 12px;\nfont-weight: 500;\nopacity: 0.6000000238418579;\n}\n.acc-collab-right{\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 7px;\n  padding: 10px;\n  width:100%;\n}\n@media only screen and (min-width: 0px) and (max-width: 480px) {\n  .collaborator-modal {\n    width: 300px;\n  }\n}\n@media only screen and (min-width: 481px) and (max-width: 767px) {\n  .collaborator-modal {\n    width: 450px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
